export const upgradeConfirmModalSx = {
  '.MuiDialog-paper': {
    width: '746px',
    padding: '72px 48px 48px 72px',
  },
};

export const upgradeConfirmModalTitleSx = { padding: 0, margin: 0 };
